import IUserGet from 'api/interfaces/users/IUserGet';
import IConfiguration from '../../../interfaces/IConfiguration';

export const allowedToDeleteOwnConfiguration = (
  user: IUserGet,
  configuration: IConfiguration
): boolean => {
  if (user == null || configuration == null) {
    return false;
  }

  return (
    user.allowedToDeleteOwnConfigurations &&
    configuration.createdUser === user.id
  );
};
